export default {
  toasts: {
    load_error: 'Gebührensätze konnten nicht geladen werden',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen gespeichert',
  },
  buttons: {
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    save: 'Speichern',
  },
  rates: {
    title: 'Verarbeitungsmarge',
    description:
      'Prozentsatz in %, dazu optional ein fester und ein Mindestbetrag pro Zahlung. „Alle Zahlungsarten“ greift, wenn kein artspezifischer Satz existiert.',
  },
};
